function randZ() {
  const alpha =
    "azertyuiopqsdfghjklmwxcvbnAZERTYUIOPQSDFGHJKLMWXCVBN1234567890";

  let tmp = "";

  for (let n = 0; n < 25; n++) {
    tmp += alpha[Math.floor(Math.random() * (alpha.length - 1))];
  }

  return tmp;
}
function closeAllCaseExcept(number = 0) {
  let allCase = document.querySelectorAll(".rightSide .case");
  allCase.forEach((element, index) => {
    element.classList.add("min");
  });

  allCase[number].classList.remove("min");

}